import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addListingType, getListingType, updateListingType, deleteListingType} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ListingType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listingtype: ''
        }
        this.handleListingTypeSubmit = this.handleListingTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (listingtype) => {
        this.setState({ listingtype: listingtype });
        this.setState({ deleteModal: true });
    };

    handleDeleteListingType = () => {
        const { onDeleteListingType} = this.props;
        const { listingtype } = this.state;

        if (listingtype.id !== undefined) {
            onDeleteListingType(listingtype);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleListingTypeSubmit(value) {
        this.props.addListingType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetListingType } = this.props;
        onGetListingType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listingtypes } = this.props;
        if (!isEmpty(listingtypes) && size(prevProps.listingtypes) !== size(listingtypes)) {
            this.setState({ listingtypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ listingtype: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const listingtype = arg;
        this.setState({
            listingtype: {
                id: listingtype.id,
                listingTypeId: listingtype.listingTypeId,
                listingTypeTitle: listingtype.listingTypeTitle,
                agentId: listingtype.agentId,
                isActive:listingtype.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { listingtypes, onUpdateListingType } = this.props;
        const { isEdit, deleteModal } = this.state;
        const listingtype = this.state.listingtype;
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteListingType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Listing Type | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Listing Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        listingTypeTitle: (this.state && this.state.listingTypeTitle) || "",
                                        agentId: parseInt(localStorage.getItem('userId'))
                                    }}
                                    validationSchema={Yup.object().shape({
                                        listingTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleListingTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Listing Type</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="listingTypeTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="listingTypeTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.listingTypeTitle && touched.listingTypeTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="listingTypeTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="listingTypeTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(listingtypes, (listingtype, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{listingtype.listingTypeTitle}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(listingtype)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(listingtype)} />
                                                                          

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: listingtype.id,
                                        listingTypeId: listingtype.listingTypeId,
                                        listingTypeTitle: listingtype.listingTypeTitle,
                                        agentId: listingtype.agentId,
                                        isActive:listingtype.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        listingTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                listingTypeId: values.listingTypeId,
                                                listingTypeTitle: values.listingTypeTitle,
                                                //agentId: values.agentId,
                                                //isActive:values.isActive
                                            };
                                            onUpdateListingType(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="listingTypeTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="listingTypeTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.listingTypeTitle && touched.listingTypeTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="listingTypeTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="listingTypeTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ListingType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addListingType : PropTypes.func,
    onGetListingType: PropTypes.func,
    listingtypes: PropTypes.array,
    onDeleteListingType: PropTypes.func,
    onUpdateListingType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        listingtypes: AppoinmentObject.listingtypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addListingType: (data) => dispatch(addListingType(data)),
    onGetListingType: (agentId) => dispatch(getListingType(agentId)),
    onDeleteListingType: (id) => dispatch(deleteListingType(id)),
    onUpdateListingType: (data) => dispatch(updateListingType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListingType))
